import React from 'react'

import { maskString } from 'utils/functions'

import { StyleSheet, Text, View } from "@react-pdf/renderer"
import DataUnavailableText from "../../DataUnavailableText"
import { DataField } from "../../../Label"
import ContentBox from "../../../ContentBox"
import ErrorDataText from "../../ErrorDataText"

const styles = StyleSheet.create({
  content: {
    marginTop: 16,
  },
})
const FamilyRelationsVariableReport = (props) => {
  const { familyRelationsData } = props
  try {
    return familyRelationsData?.has_conflicting_relatives ? (
        <ContentBox>
          <Text>
            Pessoa(s) vinculada(s):
          </Text>
          <View>
            {
              familyRelationsData?.conflicting_relatives?.map(relative => {
                return (
                  <View style={styles.content} key={relative?.relative_data?.cpf}>
                    <DataField label="Nome:" value={relative?.employee_data?.full_name} />
                    <DataField
                      label="CPF:"
                      value={maskString(relative?.relative_data?.cpf, 'cpf')}
                    />
                    <DataField label="Email:" value={relative?.employee_data?.email?.toLowerCase()} />
                    <DataField label="Gênero:" value={relative?.employee_data?.gender} />
                    <DataField
                      label="Possível parentesco:"
                      value={relative?.relative_data?.possible_kinship?.toLowerCase() || 'N/A'}
                    />
                    <DataField label="Grupo:" value={relative?.employee_data?.group} />
                    <DataField label="Empresa:" value={relative?.employee_data?.company_name} />
                    <DataField label="Unidade Organizacional:" value={relative?.employee_data?.organizational_unity} />
                    <DataField label="Cargo:" value={relative?.employee_data?.job_role} />
                    <DataField label="Senioridade:" value={relative?.employee_data?.seniority} />
                  </View>
                )
              })
            }
          </View>
        </ContentBox>
      ) :
      (
        <DataUnavailableText />
      )
  } catch (err) {
    return (
      <ErrorDataText
        exception={err}
        contextName="FamilyRelations"
        extraData={familyRelationsData}
      />
    )
  }
}

export default FamilyRelationsVariableReport
